import gql from 'graphql-tag';
import { BILLING_INFO_FRAGMENT, ORGANIZATION_FRAGMENT } from 'data/fragments/organization.fragments';

export const GET_ORGANIZATION = gql`
    query GET_ORGANIZATION {
        organizationOfUser {
            ...OrganizationFragment
        }
    }
    ${ORGANIZATION_FRAGMENT}
`;

// Requête dédiée : `billingInfo` est résolu depuis Odoo. La sortir de GET_ORGANIZATION évite que la
// latence — ou une panne — d'Odoo retarde ou casse le chargement de l'organisation (donc de toute l'app).
export const GET_ORGANIZATION_BILLING_INFO = gql`
    query GET_ORGANIZATION_BILLING_INFO {
        organizationOfUser {
            _id
            billingInfo {
                ...BillingInfoFragment
            }
        }
    }
    ${BILLING_INFO_FRAGMENT}
`;

export const GET_INVOICES = gql`
    query GET_INVOICES($organizationId: ID!, $offset: Int, $limit: Int) {
        getInvoices(organizationId: $organizationId, offset: $offset, limit: $limit) {
            invoices {
                id
                number
                description
                created
                dueDate
                status
                paid
                subtotal
                tax
                total
                pdfUrl
            }
            hasMore
        }
    }
`;

// PDF base64 à la demande (au clic) : utilisé quand une facture n'a pas de pdfUrl direct (factures Odoo).
export const GET_INVOICE_PDF_BASE64 = gql`
    query GET_INVOICE_PDF_BASE64($organizationId: ID!, $invoiceId: String!) {
        getInvoicePdfBase64(organizationId: $organizationId, invoiceId: $invoiceId)
    }
`;

export const GET_USER_GROUPS = gql`
    query GET_USER_GROUPS($organizationId: ID!) {
        userGroups(organizationId: $organizationId) {
            _id
            label
        }
    }
`;
